import * as React from 'react'
import { cn } from '../../lib/utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'flex w-full min-h-[var(--field-min-touch)] rounded-[var(--field-radius)] border border-[var(--field-border)] bg-[var(--field-bg)] px-[var(--field-padding-x)] text-[length:var(--field-font-size)] text-[var(--field-text)] placeholder:text-[var(--field-placeholder)] transition-[color,background-color,border-color,box-shadow] duration-150 focus-visible:border-[var(--field-focus-border)] focus-visible:outline-none focus-visible:shadow-[var(--field-focus-shadow)] disabled:cursor-not-allowed disabled:bg-[var(--field-disabled-bg)] disabled:text-[var(--field-disabled-text)] aria-invalid:border-[var(--field-error-border)] sm:h-[var(--field-height)] sm:min-h-[var(--field-height)]',
        className,
      )}
      {...props}
    />
  ),
)
Input.displayName = 'Input'
